<template>
  <div class="project-schedules">
    <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Select a schedule</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>
          <template v-if="loading">
            <loading />
          </template>

          <template v-if="!loading && schedules.length">
            <div
              v-for="(schedule, index) in schedules"
              :key="'schedule' + index"
              class="schedule"
            >
              <v-hover v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 12 : 0"
                  class="py-1 px-2 d-flex flex-wrap justify-space-between cursor-pointer"
                  @click="goToSchedule(schedule.name)"
                >
                  <div class="mb-1 mb-sm-0">
                    <h6 class="primary--text pb-0 mb-0">
                      <strong>{{ schedule.name }}</strong>
                    </h6>
                    <div v-if="getCurrentVersion(schedule.versions)">
                      <strong>Current Version: </strong>
                      <span>{{
                        getCurrentVersion(schedule.versions).number
                      }}</span>
                    </div>
                    <div>
                      <strong class="mr-1">Previous Version: </strong>
                      <v-chip
                        v-for="version in schedule.versions"
                        :key="version.number"
                        color="primary"
                        small
                        class="px-2 mr-1"
                        >{{ version.number }}</v-chip
                      >
                    </div>
                  </div>
                  <div v-if="getCurrentVersion(schedule.versions)">
                    <strong>Published: </strong>
                    <span
                      v-if="getCurrentVersion(schedule.versions).published_on"
                      >{{
                        new Date(
                          getCurrentVersion(schedule.versions).published_on
                        ).toLocaleDateString()
                      }}</span
                    >
                    <span v-else>N/A</span>
                  </div>
                </v-card>
              </v-hover>
              <v-divider class="ma-1"></v-divider>
            </div>
          </template>
        </v-card-text>

        <div v-if="pagination" class="text-center pb-3">
          <v-pagination
            v-model="pagination.page"
            :length="pagination.totalPages"
            @input="paginateSchedules"
          ></v-pagination>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      schedules: [],
      pagination: null
    };
  },
  created() {
    this.getProjectSchedules();
  },

  methods: {
    getProjectSchedules(payload = null) {
      let request = {
        id: this.project.uuid,
        page: 1
      };

      if (payload) {
        request.page = payload.page;
      }

      this.schedules = [];
      this.loading = true;
      this.$store
        .dispatch("schedule/getProjectSchedules", request)
        .then(resp => {
          this.schedules = JSON.parse(JSON.stringify(resp.schedule));
          this.pagination = { ...resp.pagination };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    paginateSchedules(value) {
      this.getProjectSchedules({ page: value });
    },
    getCurrentVersion(versions) {
      if (versions && versions.length) {
        return versions[versions.length - 1];
      }

      return null;
    },
    goToSchedule(name) {
      this.$router.push(`/project/${this.project.uuid}/schedule/${name}`);
    }
  }
};
</script>
